import { render } from "./affiliate-review-page.vue?vue&type=template&id=036e0c68&scoped=true&ts=true"
import script from "./affiliate-review-page.vue?vue&type=script&lang=ts"
export * from "./affiliate-review-page.vue?vue&type=script&lang=ts"

import "./affiliate-review-page.vue?vue&type=style&index=0&id=036e0c68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036e0c68"]])

export default __exports__